import { raygun } from '@ynap/clientside-monitoring'

const reportToRaygun = (message, { requestBody, error }) =>
    raygun.helpers.agent('send', {
        error: new Error(message),
        tags: ['delete', 'delete-account', 'delete-account-error'],
        customData: {
            requestBody,
            errorString: error.toString(),
        },
    })

export const deleteAccount = async ({ baseUrl, storeIdentifier, ubertoken, clientId }) => {
    return fetch(`${baseUrl}wcs/resources/store/${storeIdentifier}/person/requestoblivion`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-ubertoken': ubertoken,
            'x-ibm-client-id': clientId,
        },
        body: '{}',
    })
        .then(async (res) => {
            if (!res.ok) {
                const error = await res.text()
                throw new Error(error)
            }
            return res.json()
        })
        .catch((e) => {
            reportToRaygun(
                `Unsucessful response when hitting ${baseUrl}wcs/resources/store/${storeIdentifier}/person/requestoblivion`,
                {
                    error: e,
                }
            )
            throw new Error(e)
        })
}
